function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon/ID/card/new/white",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-1",
  stroke: "#FFFFFF",
  strokeWidth: 1.6,
  points: "1 17 23 17 23 1 1 1"
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.7857143,
  y1: 5,
  x2: 19.8571429,
  y2: 5,
  id: "Stroke-3",
  stroke: "#FFFFFF",
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.7857143,
  y1: 8.2,
  x2: 19.8571429,
  y2: 8.2,
  id: "Stroke-4",
  stroke: "#FFFFFF",
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-5",
  stroke: "#FFFFFF",
  strokeWidth: 1.6,
  points: "4.14285714 12.2 9.64285714 12.2 9.64285714 5 4.14285714 5"
}));

function SvgWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "18px",
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/ID/card/new/white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/white.bd0d7dca.svg";
export { ForwardRef as ReactComponent };